
import './styles.css';
import InsaneTable from '../../component/insane-table';

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function MaintenanceStandardGas() {
    
    let gasTypeList = [];
    
    HttpRequest("/admin/mt/standard/get", {}).then(data => {
        // console.log("gasTypeList" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.standards.length; i++) {
                const _standards = data.standards[i];
                gasTypeList.push({
                    displayName: _standards.gastype + " - " + _standards.standardname,
                    value: _standards.gastype
                })
            }
        }
    });

    const tableOption = {
        tableName: "Standard Gas",
        className: "",
        search: [
            {
                reqName: "gasid",
                displayName: "Gas ID",
                element: "input",
                placeholder: "Enter Gas ID."
            },
            {
                reqName: "tagid",
                displayName: "Tag ID",
                element: "input",
                placeholder: "Enter Tag ID."
            },
            {
                reqName: "gastype",
                displayName: "Gas Type",
                element: "select",
                placeholder: "Select Gas Type.",
                option: gasTypeList
            }
        ],
        mapTable: [
            {
                displayName: "GasID",
                attName: "gasid",
                type: "text",
                form: {
                    validate: true,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "TagID",
                attName: "tagid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Name",
                attName: "name",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Gas type",
                attName: "gastype",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    placeholder: "Select Gas Type.",
                    element: "select",
                    option: gasTypeList
                }
            },
            {
                displayName: "Equipment Tag ID",
                attName: "equipment_tagid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Start date",
                attName: "startdate",
                type: "date",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Expire date",
                attName: "expiredate",
                type: "date",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Standard value",
                attName: "standardvalue",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Unit",
                attName: "unit",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/mt/gas/get",
                dataReq: {
                    "index": 0,
                    "count": 10
                }
            },
            insert: {
                enable: true,
                url: "/admin/mt/gas/update",
                dataReq: {
                    "tagid": "",
                    "name": "",
                    "gastype": "",
                    "equipment_tagid": "",
                    "startdate": "",
                    "expiredate": "",
                    "standardvalue": "",
                    "unit": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/mt/gas/update",
                dataReq: {
                    "tagid": "",
                    "name": "",
                    "gastype": "",
                    "equipment_tagid": "",
                    "startdate": "",
                    "expiredate": "",
                    "standardvalue": "",
                    "unit": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/mt/gas/delete",
                dataReq: {
                    "gasid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            },
            {
                name: "Usage Log",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/maintenance/standard-gas/log"
                }
            }
        ],
        qr: {
            type: "",
            sampleValue: {
                tagid: ""
            },
            option: { 
                bgColor: '#FFFFFF',
                fgColor: '#000000',
                level: 'L',
                size: 64,
                title: ""
            },
            mapValue: [
                {
                    attName: "tagid",
                    attMap: "tagid",
                    type: "text",
                }
            ]
        }
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Standard Gas.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default MaintenanceStandardGas;